export default __webpack_public_path__ + "static/media/SeaLife_33.50170b35.png";